import API from './api';

export default class TutorialDetail extends API {}
